export interface IAddNewDevice {
  serial: string;
  transferCode: string;
}

export const initialAddNewDevice: IAddNewDevice = {
  serial: "",
  transferCode: ""
};
